import { FormLabel } from '@mui/material';
import { TextEditor, TextEditorProps } from '../TextEditor/TextEditor';
import './TextEditorWithLabel.scss';

export const TextEditorWithLabel = ({
  name,
  placeholder,
  isDisabled,
  'data-testid': dataTestId,
  label,
  isRequired,
  onSubmit,
  isModal,
}: TextEditorProps) => {
  return (
    <div className="text-editor-with-label-container">
      <FormLabel className="text-editor-with-label" required={isRequired}>
        {label}
      </FormLabel>
      <TextEditor
        name={name}
        placeholder={placeholder}
        isDisabled={isDisabled}
        data-testid={dataTestId}
        label={label}
        isRequired={isRequired}
        onSubmit={onSubmit}
        isModal={isModal}
      />
    </div>
  );
};
